import { Injectable } from '@angular/core';
import { User, stripeRedirect } from 'src/app/shared/constants/url.constants';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpParams, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { StorageService } from './storage.service';
import { UikitService } from './uikit.service';
import { environment } from 'src/environment';
import { PaymentService } from './payment.service';
import { ApplicationService } from './application.service';
import { LoggerService } from '../authentication/logger.service';


@Injectable({
  providedIn: 'root'
})
export class MyAccountService {

  updateIndex = new BehaviorSubject<boolean>(false);
  constructor(private http: HttpClient, private storageservice: StorageService, private uikitService: UikitService
              ,private storageService: StorageService, private paymentService: PaymentService, public appService:ApplicationService,
              private loggerService: LoggerService) { }

  getAccountDetails(): Observable<any> {
    const accountUrl = environment.apiEndpoint + environment.version + User;
    const profileId = this.storageService.getSessionStore('profileId');
    const uId = this.storageService.getLocalStore('u_id');
    let params = new HttpParams();
    params = params.append('d_type', 'web');
    params = params.append('profile_id', profileId ?  profileId : uId);
    return this.http.get(accountUrl, { params }).pipe(
      map(
        (response: any) => {
          if (response.status_code === 200) {
            this.paymentService.paymentMethodLength = response.data.stripe_payment_method.length;
            this.appService.userLoginBy = response.data.user_login_by;
            this.appService.userIntegrationType = response.data.user_integration_type;
            this.loggerService.checkReccuringPaymentInfo(response.data);
            return response.data;
          }
        }
        , (error: HttpErrorResponse) => {
          console.log(error);
        }
      )
    );
  }

  updateData(): Observable<any> {
    const updateMethodUrl = environment.apiEndpoint + environment.version + stripeRedirect;
    const userId: string = this.storageService.getLocalStore('u_id');
    const data = { u_id: userId};
    return this.http.post(updateMethodUrl, data).pipe(
      map((response: any) => {
        if (response.status_code === 200) {
          return response.data;
        }
        else {
          this.uikitService.notifyError(response);
        }
      }), catchError((error) => {
        if (error?.error?.error?.code !== 1002) {
          this.uikitService.notifyError(error);
        }
        return error;
      })
    );
  }
}
